// extracted by mini-css-extract-plugin
export var standaloneTable = "_ha-0";
export var standaloneTableWithBodyFill = "_ha-1";
export var withExtraHeader = "_ha-2";